var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-row align-items-center" },
    [
      _c("material-input", {
        attrs: {
          value: _vm.parsedValue,
          label: _vm.name.label,
          "label-for":
            _vm.type === "date"
              ? ""
              : "custom-field-" + _vm.name.label + "-" + _vm.labelValue,
          "custom-expression": "valueModel",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var $error = ref.$error
              return [
                _c(_vm.componentFromType, {
                  tag: "component",
                  class: {
                    "form-control-filled":
                      _vm.parsedValue || _vm.type === "monetary",
                    error: $error,
                    "material-input form-control form": _vm.type !== "date",
                  },
                  attrs: {
                    disabled: _vm.disabled,
                    value: _vm.valueModel,
                    placeholder: _vm.name.label,
                    data: _vm.selectOptions,
                    name: "custom-field",
                    "data-lpignore": "true",
                  },
                  on: { change: _vm.handleChange },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.type === "email"
        ? _c(
            "a",
            {
              staticClass: "pb-3",
              class: { disabled: !_vm.valueModel },
              attrs: {
                href: _vm.valueModel ? "mailto:" + _vm.valueModel : null,
              },
            },
            [
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      title: _vm.$t("global.actions.sendExternalEmail"),
                      disabled: !_vm.valueModel,
                      placement: "right",
                    },
                    expression:
                      "{\n        title: $t('global.actions.sendExternalEmail'),\n        disabled: !valueModel,\n        placement: 'right'\n      }",
                  },
                ],
                staticClass: "text-light-gray",
                attrs: { name: "envelope-o" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }